export const DATE_WITH_TIME_FORMAT = 'yyy-MM-dd HH:mm:SS';
export const DATE_HYPHEN_FORMAT = 'YYY-MM-dd';
export const DATE_DOT_FORMAT = 'dd.MM.yyyy';
export const DATE_SLASH_FORMAT = 'MM/DD/YYYY';

export const DATE_SLASH_FORMAT_2 = 'MM/dd/yyyy';
export const DATE_SLASH_FORMAT_WITH_TIME = 'MM/dd/yyyy HH:mm';
export const DATE_SLASH_FORMAT_WITH_TIME_PICKER = 'MM/DD/YYYY HH:mm';
export const DATE_SLASH_FORMAT_WITH_FULL_TIME_PICKER = 'MM/DD/YYYY HH:mm:ss';
export const DATE_SLASH_FORMAT_WITH_FULL_TIME = 'MM/dd/yyyy HH:mm:ss';

export const DATE_DOT_FORMAT_WITH_TIME = 'dd.MM.yyyy HH:mm';

export const DATE_HYPHEN_FORMAT_WITH_FULL_TIME_PICKER = 'YYYY-MM-DD HH:mm:ss';

export const TIME_FORMAT = 'HH:mm';
export const TIME_FORMAT_FULL = 'HH:mm:ss';

// Day JS
export const DATE_DOT_FORMAT_2 = 'DD.MM.YYYY';
